import { call, put, takeLatest } from 'redux-saga/effects';
import uniqid from 'uniqid';
import { VERIFY_MSTEAMS } from './constants';
import { verifyMsteams } from './actions';
import triggerNotification from 'utils/triggerNotification';
import { NOTIFICATION } from 'common/constants';
import request from 'utils/request';
import { MSTEAMS_VERIFY } from 'common/strings';
import convertErrorMsg from 'utils/convertErrorMsg';
import localStorageTemplates from 'common/local-storage-templates';
import { readToken } from 'utils/readToken';

export function* saveMsteamsCode({ payload, metadata }) {
  const token = readToken();
  const { projectName } = metadata;
  try {
    const response = yield call(request, {
      method: 'post',
      endpoint: 'app/integration/msteams',
      projectName,
      config: {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: {
          ...payload,
        },
      },
    });

    triggerNotification({
      title: MSTEAMS_VERIFY.ALERTS.INTEGRATE_HUBSPOT_SUCCESS,
      type: NOTIFICATION.TYPE.SUCCESS,
    });
    yield put(verifyMsteams.success());
  } catch (error) {
    const errorMessage = convertErrorMsg(error);

    triggerNotification({
      title: errorMessage,
      type: NOTIFICATION.TYPE.ERROR,
    });
    yield put(verifyMsteams.error(errorMessage));
  }
}

export default function* msTeamsVerify() {
  yield takeLatest(VERIFY_MSTEAMS.START, saveMsteamsCode);
}
